import { flagEnabled } from './index';

/**
 * Centralizes all Cotton (Kotlin MW) feature flag logic.
 * - masterFlag: Controls all Cotton traffic.
 * - cottonAllowed: Cookie gate for Cotton traffic.
 * - Granular flags: Chained with masterFlag and cottonAllowed.
 */

const cottonFlagManager = {
// Master switch for all Cotton APIs
  get masterFlag() {
    return flagEnabled('cottonFeatureEnabled');
  },
  // Akamai cookie
  get cottonAllowed() {
    return true;
  },
  // Core gating logic - all cotton flags must pass these checks
  /**
   * Creates a cotton-gated flag checker
   * @param {string} flagName - The specific feature flag name
   * @returns {boolean} - Whether the feature is enabled
   */
  createGatedFlag(flagName) {
    return this.isBaseEnabled && flagEnabled(flagName);
  },
  get isBaseEnabled() {
    return this.masterFlag && this.cottonAllowed;
  },
  // Account API flag
  get accountEnabled() {
    return this.createGatedFlag('cottonAccountApiEnabled');
  },
  // OAuth API flag
  get oauthEnabled() {
    return this.createGatedFlag('cottonOauthEnabled');
  },
  // Macaroon API flag
  get macaroonEnabled() {
    return this.createGatedFlag('cottonMacaroonEnabled');
  },
  // Swaps Orders API flag
  get swapsOrdersEnabled() {
    return this.createGatedFlag('cottonSwapsOrdersEnabled');
  },
  // Swaps Order API flag
  get swapsOrderEnabled() {
    return this.createGatedFlag('cottonSwapsOrderEnabled');
  },
  // Swaps Eligibility API flag
  get swapsEligibilityEnabled() {
    return this.createGatedFlag('cottonSwapsEligibilityEnabled');
  },
  // HIC API flag
  get hicEnabled() {
    return this.createGatedFlag('cottonHicEnabled');
  },
  // DSM Devices API flag
  get dsmDevicesEnabled() {
    return this.createGatedFlag('cottonDsmDevicesEnabled');
  },
  // DSM Returns API flag
  get dsmReturnsEnabled() {
    return this.createGatedFlag('cottonDsmReturnsEnabled');
  },
  // DSM Returns Label API flag
  get dsmReturnsLabelEnabled() {
    return this.createGatedFlag('cottonDsmReturnsLabelEnabled');
  },
  // DSM Returns New Label API flag
  get dsmReturnsNewLabelEnabled() {
    return this.createGatedFlag('cottonDsmReturnsNewLabelEnabled');
  },
  // Outage Consolidated LOB API flag
  get consolidatedOutageLobEnabled() {
    return this.createGatedFlag('cottonConsolidatedOutageLob');
  },
  // Device Status Cotton API flag
  get deviceStatusApiEnabled() {
    return this.createGatedFlag('cottonDeviceStatusEnabled');
  },
  // Outage API flag
  get outageEnabled() {
    return this.createGatedFlag('cottonOutageEnabled');
  },
  // Master switch for all oauth Ruby APIs
  get disableRubyApis() {
    return this.createGatedFlag('disableRubyApis');
  },
  // APT auth flow flag
  get isAptV1Enabled() {
    return this.createGatedFlag('isAptV1Enabled');
  },
  // ITG Recommendations API flag
  get itgRecommendationsEnabled() {
    return this.createGatedFlag('cottonItgRecommendationsEnabled');
  },
  // SIK Order API flag
  get sikOrderEnabled() {
    return this.createGatedFlag('cottonSikOrderEnabled');
  },
  get cmsSupportEnabled() {
    return this.createGatedFlag('cottonCmsSupportEnabled');
  },
  // Internet usage
  get internetUsageEnabled() {
    return this.createGatedFlag('cottonInternetUsageEnabled');
  },
  get internetPlanEnabled() {
    return this.createGatedFlag('cottonInternetPlanEnabled');
  },
};

export default cottonFlagManager;
